import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var Parallax = /*#__PURE__*/function () {
  function Parallax() {
    _classCallCheck(this, Parallax);
    this.enable = false;
    this.force = 2;
    this.smooth = 10;
  }
  _createClass(Parallax, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.force !== undefined) {
        this.force = data.force;
      }
      if (data.smooth !== undefined) {
        this.smooth = data.smooth;
      }
    }
  }]);
  return Parallax;
}();